import { MessageRoleEnum } from '@va/dashboard/shared/ai-assistant';
import { useTranslate } from '@va/localization';
import { useEffect, useMemo, useRef } from 'react';
import { useAiChatbotContext } from '../../aiChatbotContext';
import { useChatDetailsContext } from './ChatDetailsContext';
import { ChatMessage } from './ChatMessage';

export const ChatMessages = () => {
  const { conversation, messages, liveMessage, isThinking } = useChatDetailsContext();
  const { selectedModel } = useAiChatbotContext();
  const containerRef = useRef<HTMLDivElement>(null);
  const translate = useTranslate();

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    requestAnimationFrame(() => {
      container.scrollTo({ top: container.scrollHeight });
    });
  }, [liveMessage, messages]);

  const isThinkingInternal = useMemo(() => {
    if (isThinking && !liveMessage) return true;
    if (liveMessage) return false;

    const lastMessage = messages?.at(-1);
    if (lastMessage?.role === MessageRoleEnum.assistant) {
      return lastMessage?.content === '' && lastMessage?.toolCalls?.length;
    }
    if (lastMessage?.role === MessageRoleEnum.tool) {
      return true;
    }

    return false;
  }, [isThinking, liveMessage, messages]);

  if (!messages) {
    return <></>;
  }

  return (
    <div ref={containerRef} className={'flex flex-col gap-4u pt-4u overflow-y-auto scrollbar scrollbar-thumb flex-1'}>
      {messages.map((m) => (
        <ChatMessage key={m.id} {...m} />
      ))}

      {isThinkingInternal && (
        <ChatMessage
          key={'thinking'}
          id={'thinking'}
          content={translate('aiChatbot.chatMessage.thinking')}
          conversationId={''}
          createdAt={''}
          model={selectedModel ?? conversation?.selectedModel ?? ''}
          role={MessageRoleEnum.assistant}
          toolCalls={null}
          remoteId={null}
          pulse={true}
        />
      )}

      {liveMessage && (
        <ChatMessage
          key={'live'}
          id={'live'}
          content={liveMessage}
          conversationId={conversation?.id ?? ''}
          createdAt={''}
          model={selectedModel ?? conversation?.selectedModel ?? ''}
          role={MessageRoleEnum.assistant}
          toolCalls={null}
          remoteId={null}
        />
      )}
    </div>
  );
};
